import axios from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'

import { getUserToken } from '../stores/currentUser'

const API_ROOT = process.env.REACT_APP_API_ROOT

const api = axios.create()

api.interceptors.request.use((req) => {
  const userToken = getUserToken()
  const headers = { ...req.headers }

  req.url = `${API_ROOT}${req.url}`
  req.headers.Authorization = userToken
  req.headers.Accept = '*/*'
  req.headers = { ...req.headers, ...headers }

  if (req.url.includes(API_ROOT)) {
    req.data = decamelizeKeys(req.data)
  }

  return req
})

api.interceptors.response.use((res) => {
  if (res.config.url.includes(API_ROOT)) {
    res.data = camelizeKeys(res.data)
  }

  return res
})

export type ParametersExceptFirst<F> = F extends (
  arg0: any,
  ...rest: infer R
) => any
  ? R
  : never

export type AxiosExceptUrl<T = typeof api.post> = ParametersExceptFirst<T>

export default api
